/** Each image model as people know it, shared by the composer's pickers and the agent's questions. */
export const IMAGE_MODEL_LABELS = {
    'gemini-nano-banana-2.1': 'Nano Banana 2.1',
    'gemini-3-pro-image': 'Nano Banana Pro',
    'gemini-3.1-flash-image': 'Nano Banana 2',
    'dall-e-3': 'DALL·E 3',
    'gpt-image-1': 'GPT Image 1',
    'gpt-image-2.5-sunburst': 'GPT Image 2.5 Sunburst',
    'gpt-image-2.5-flare': 'GPT Image 2.5 Flare',
    'gpt-image-2': 'GPT Image 2',
    'firefly-v3': 'Adobe Firefly V3',
    'firefly-v4-standard': 'Adobe Firefly V4 Standard',
};
export const imageModelLabel = (model) => IMAGE_MODEL_LABELS[model] ?? model;
